import { SvgTypesProps } from '@/shared/types/SvgTypes';

export function IconAdd({
  fill = 'var(--ruby-10)',
  width = 16,
  height = 16,
}: SvgTypesProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="6" fill="#F5290A"/>
      <path d="M8 5.5V10.5M5.5 8H10.5" stroke="white" strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  );
}
